import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'

export interface GalleryProps {}

export const useGallery = (props: GalleryProps) => {
  const departmentDetails = useSelector(
    (state: RootState) => state.department.departmentDetails
  )

  return {
    ...props,
    departmentDetails,
  }
}
